// Constants - action names
export const SHOW_NOTIFICATION = 'pv-kultu/notification/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'pv-kultu/notification/HIDE_NOTIFICATION';

// Helpers
// --

// Initial state
const initialState = {
  notificationType: undefined,
  notificationProps: {}
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return Object.assign({}, state, {
        notificationType: action.notificationType,
        notificationProps: action.notificationProps
      });
    case HIDE_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
}

// Actions
export function showNotification(notificationType, notificationProps) {
  return {type: SHOW_NOTIFICATION, notificationType, notificationProps};
}

export function hideNotification() {
  return {type: HIDE_NOTIFICATION};
}


// WEBPACK FOOTER //
// ./src/ducks/notification.js